import axiosClient from './axiosClient';

export interface SendSharePayload {
  recipients: string[];
  subject?: string;
  message?: string;
  link?: string;
}

export const shareAPI = {
  send: async (payload: SendSharePayload): Promise<{ success: boolean }> => {
    const res = await axiosClient.post<{ success: boolean }>(`/share/send`, payload);
    return res.data;
  },
};



